import React from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { PaginationControl, PaginationLink } from '../styles';

var NextButton = function NextButton(_ref) {
  var currentPage = _ref.currentPage,
      onChangePage = _ref.onChangePage,
      pageUrls = _ref.pageUrls;
  // setting this to undefined (aka on last when this button is hidden) for some reason
  // breaks the href on the other pages where the button is actually visible
  var page = Math.min(currentPage + 1, pageUrls.length - 1);
  return /*#__PURE__*/React.createElement(PaginationControl, {
    isHidden: currentPage === pageUrls.length - 1
  }, /*#__PURE__*/React.createElement(PaginationLink, {
    hasButtonBehavior: true,
    href: pageUrls[page],
    onClick: function onClick(e) {
      onChangePage(page, e);
    },
    "aria-label": "next page",
    "data-test": "pagination-next"
  }, "Next", /*#__PURE__*/React.createElement(ChevronIcon, {
    size: "xsmall",
    pointing: "right"
  })));
};

NextButton.displayName = 'NextButton';
export default NextButton;